import { createSlice } from "@reduxjs/toolkit";

const getStored = (key, fallback) => {
  try {
    const value = localStorage.getItem(key);

    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

const initialState = {
  config: getStored("siteConfig", {}),
  country: getStored("country", "US"),
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.config = action.payload;
      localStorage.setItem("siteConfig", JSON.stringify(action.payload));
    },
  },
});

export const { setConfig } = configSlice.actions;

export default configSlice.reducer;
